
import { http } from '@pendo/http';
import { v4 as uuid } from 'uuid';

export const WARNING_TYPES = {
    ANALYTICS_DELAYED: 'ANALYTICS_DELAYED',
    FIRST_ID_LOOKS_LIKE_HEADER: 'FIRST_ID_LOOKS_LIKE_HEADER',
    VISITOR_IDS_NOT_FOUND: 'VISITOR_IDS_NOT_FOUND',
};

const SAVED = 1;
const INITIALIZED = 5;
const UPLOADED = 10;
const STARTED = 20;

export function postToGCS (url, file, data) {
    const fd = new FormData();
    Object.keys(data).forEach((key) => {
        fd.append(key, data[key]);
    });
    fd.append('file', file); // must be the last entry

    return http.post(url, fd, { withCredentials: false, headers: { 'Content-Type': 'multipart/form-data' } });
}

export async function getId (kind, file) {
    if (file.id) {
        return { id: file.id };
    }

    return http.post(`/api/s/_SID_/entitytag/${kind}`, { name: file.name }).then((res) => res.data);
}

export async function uploadCsv (kind, file, params) {
    return http
        .post(`/api/s/_SID_/entitytag/${kind}/${file.id}/uploadcsv`, { name: file.name, ...params })
        .then((res) => res.data);
}

export async function processCsv (kind, file, params) {
    return http
        .post(`/api/s/_SID_/entitytag/${kind}/${file.id}/processcsv`, { name: file.name, ...params })
        .then((res) => res.data);
}

export async function pollStatus (requestId, notify, shouldLogStatus) {
    let status = {};

    try {
        status = await http.get(`/api/s/_SID_/entitytag/status/${requestId}`).then((res) => res.data);
    } catch (error) {
        throw error;
    }

    // Early status calls return {}
    if (!status.command) return 0;

    if (status.command === 'progress') {
        const { entityTagsApplied, entityTagsTotal } = status;
        const progress = STARTED + Math.round((entityTagsApplied / entityTagsTotal) * (100 - STARTED));
        notify(progress);

        // eslint-disable-next-line no-console
        if (shouldLogStatus) console.info('[CSV Upload] Status: ', status);

        return 0;
    }

    // status.command === 'finished || status.command === 'error'
    notify(status);

    return 1;
}

export async function upload (kind, file, notify = () => {}, params = {}) {
    const requestId = params.requestId || `req-${uuid()}`;

    try {
        const { id } = await getId(kind, file);
        notify(SAVED);
        file.id = id;

        const { uploadUrl, url, formData } = await uploadCsv(kind, file, { requestId, ...params });
        notify(INITIALIZED);

        await postToGCS(uploadUrl, file, formData);
        notify(UPLOADED);

        await processCsv(kind, file, {
            requestId,
            gcsUrl: url,
            ...params,
        });
        notify(STARTED);

        let pollingInterval;
        const uploadPromise = new Promise((resolve, reject) => {
            let timesPolled = 0;
            pollingInterval = window.setInterval(async () => {
                timesPolled++;
                const shouldLogStatus = !(timesPolled % 10);
                try {
                    const isFinished = await pollStatus(requestId, notify, shouldLogStatus);
                    if (!isFinished) return;

                    window.clearInterval(pollingInterval);
                    resolve();
                } catch (err) {
                    reject(err);
                }
            }, 1000);
        });

        return {
            entityTagId: id,
            uploadPromise,
            pollingInterval,
        };
    } catch (error) {
        notify(error);

        throw error;
    }
}
